import React, { FC } from 'react'
import TSvgProps from './type/svgPropsType'

const TagIcon: FC<TSvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-label="태그"
      {...props}
    >
      <desc>태그</desc>
      <path fill="none" d="M0 0h20v20H0z"></path>
      <circle cx="10" cy="10" r="8" fill="#555"></circle>
      <g fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1.2">
        <path d="M6.359 8.635h7.282M11.366 6.36v7.282M6.359 11.365h7.282M8.635 6.359v7.282"></path>
      </g>
    </svg>
  )
}

export default TagIcon
